<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование скрипта" : "Добавление скрипта"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='item'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("description")'
            :error-messages='errors.first("description")'
            v-model='item.description'
            label='Описание'
            counter
          )
        v-flex(xs6)
          v-checkbox(
            v-model='item.only_authorized'
            label='Только для авторизованных'
            color='primary'
          )
        v-flex(xs6)
          v-checkbox(
            v-model='item.only_guest'
            label='Только для гостей'
            color='primary'
          )
        v-flex(xs12)
          v-select(
            v-if='attributes'
            :error='errors.has("site_ids")'
            :error-messages='errors.first("site_ids")'
            :items='attributes.sites'
            item-text='name'
            item-value='id'
            v-model='sites'
            label='Сайты для публикации'
            multiple
            chips
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("head")'
            :error-messages='errors.first("head")'
            v-model='item.head'
            label='Секция <head>'
            counter
            rows="12"
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("body_start")'
            :error-messages='errors.first("body_start")'
            v-model='item.body_start'
            label='Секция <body> начало'
            counter
            rows="12"
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("body_end")'
            :error-messages='errors.first("body_end")'
            v-model='item.body_end'
            label='Секция <body> конец'
            counter
            rows="12"
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import http from "@/http";
import { createFormData } from '@/utils'

export default {
  props: ['id'],

  data: () => ({
    item: {},
    attributes: {}
  }),

  async created() {
    this.fetchAttributes()
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async fetchAttributes() {
      try {
        const res = await http.get('/sites/scripts/attributes')
        this.attributes = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async updateItem() {
      this.item = (await this.fetchSingle({ id: this.id })).data
    },

    async onSave() {
      let data = createFormData(this.item)

      try {
        if (this.id) {
          await this.update({ id: this.id, data })
        } else {
          await this.create({ data })
        }
        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Content.Scripts' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('content/scripts', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    sites: {
      get() {
        let { site_ids } = this.item

        if (!site_ids) {
          return []
        }
        var res = site_ids.split(/,/).map(x => +x)
        return res
      },

      set(val) {
        this.item.site_ids = val.join(',')
      }
    },
    ...mapGetters('content/scripts', ['isLoading'])
  }
}
</script>

<style>
.small textarea {
  font-size: 12px;
}
</style>
